/// <reference path="../../../_references.d.ts" />

import { LatestWebinarController } from './controller';

export function LatestWebinarDirective() : ng.IDirective<ng.IScope> {
    return {
        templateUrl: '/partials/main/dashboard/latestWebinarDirective/template',
        restrict: 'E',
        scope: {
            location: '=',
        },
        controller: LatestWebinarController,
        controllerAs: 'ctrl',
        bindToController: true,
    };
}
